const icoSettings = function reducer(
  state = {
    sidebar: false,
    downloadAction: false,
    svgDownloadAction: false,
    packageDownload: false,
    isHorizontal: false,
  },
  action
) {
  switch (action.type) {
    case "SIDEBAR_SETTINGS": {
      return { ...state, sidebar: action.payload };
    }
    case "SET_SETTINGS": {
      return { ...state, ...action.payload };
    }
    case "TOGGLE_HORIZONTAL": {
      return { ...state, isHorizontal: action.payload };
    }
  }
  return state;
};
/* jshint camelcase: false */
export default icoSettings;
